import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CardListItem from './CardListItem';
import CategoriesFilter from './CategoriesFilter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: '1em',
    },
  })
);

interface CardListProps {
  selectedCategorySlug: string | null;
}

const CardList = ({ selectedCategorySlug }: CardListProps) => {
  const {
    allWpCard: { nodes: allCards },
  } = useStaticQuery(graphql`
    query CardListQuery {
      allWpCard(
        sort: { fields: categories___nodes___acfCategory___order, order: ASC }
        filter: { acfCard: { available: { eq: true } } }
      ) {
        nodes {
          id
          title
          slug
          categories {
            nodes {
              slug
              name
            }
          }
        }
      }
    }
  `);

  const classes = useStyles();
  const [filteredList, setFilteredList] = useState(allCards);

  useEffect(() => {
   if (selectedCategorySlug) {
    const filteredByCategory = allCards.filter(({ categories: { nodes: cardCategories } }) =>
      cardCategories.some(({ slug }) => slug === selectedCategorySlug)
    );

    // If selected category is 'inne' ("other") show cards with 'inne' category and cards without any category
    const filteredByInne = selectedCategorySlug === 'inne'
      ? allCards.filter(({ categories: { nodes: cardCategories } }) =>
          cardCategories.some(({ slug }) => slug === 'inne') || cardCategories.length === 0
        )
      : [];

    setFilteredList(filteredByCategory.length ? filteredByCategory : filteredByInne);
    } else {
      setFilteredList(allCards);
    }
  }, [selectedCategorySlug, allCards]);

  return (
    <>
      <CategoriesFilter selectedCategorySlug={selectedCategorySlug} />
      <Grid container spacing={8} className={classes.root}>
        {filteredList.map(({ id, title, slug }) => {
          const uri = `/ekartki/${slug}`;
          return (
            <CardListItem
              key={id}
              cardId={id}
              title={title}
              uri={uri}
            ></CardListItem>
          );
        })}
      </Grid>
    </>
  );
};

export default CardList;
